<dm-dropdown placement="right-end" class="lp-account-menu" [fullWidth]="!collapsed()">
  <!-- Never swap this element via @if/@else — dm-dropdown binds its handlers
       to it once. `collapsed` reduces the card to a bare avatar for the icon rail
       and keeps label/subtitle bound, so nothing needs rebinding when it expands. -->
  <dm-account-card
    class="lp-account-menu__card"
    size="md"
    [collapsed]="collapsed()"
    [label]="accountName()"
    [subtitle]="email()"
    [initials]="accountInitials()"
    [imgsrc]="imgsrc()"
    aria-label="Kontomenü öffnen"
    i18n-aria-label="@@account.menu.open"
  />
  <dm-dropdown-content>
    <div class="lp-account-menu__group">
      <!-- Primary items sit in a white card; Log Out sits below on the grey surface. -->
      <div class="lp-account-menu__primary">
        <dm-dropdown-item icon="user-01" label="Profil" i18n-label="@@account.menu.profile" (dmSelect)="goToProfile()" />

        <dm-dropdown-sub class="lp-account-menu__language">
          <dm-dropdown-sub-trigger icon="globe-01">
            <span i18n="@@account.menu.language">Sprache</span>
          </dm-dropdown-sub-trigger>
          <dm-dropdown-content>
            <dm-dropdown-radio-group [value]="currentLanguage" (dmRadioChange)="switchLanguage($event.detail)">
              @for (language of languages(); track language.code) {
                <dm-dropdown-item selectionIndicator="radio" [value]="language.code">
                  {{ language.label }}
                </dm-dropdown-item>
              }
            </dm-dropdown-radio-group>
          </dm-dropdown-content>
        </dm-dropdown-sub>

        @if (colorSchemeService.isSwitchAvailable()) {
          <dm-dropdown-sub class="lp-account-menu__color-scheme">
            <dm-dropdown-sub-trigger [icon]="colorSchemeIcon()">
              <span i18n="@@account.menu.colorScheme">Darstellung</span>
            </dm-dropdown-sub-trigger>
            <dm-dropdown-content>
              <dm-dropdown-radio-group [value]="colorSchemeService.choice()" (dmRadioChange)="switchColorScheme($event.detail)">
                @for (option of colorSchemeOptions; track option.value) {
                  <dm-dropdown-item selectionIndicator="radio" [value]="option.value" [icon]="option.icon" [label]="option.label" />
                }
              </dm-dropdown-radio-group>
            </dm-dropdown-content>
          </dm-dropdown-sub>
        }
      </div>

      <dm-dropdown-item icon="log-out-01" label="Abmelden" i18n-label="@@account.menu.logout" (dmSelect)="logout.emit()" />
    </div>
  </dm-dropdown-content>
</dm-dropdown>
